import { useTranslation } from 'react-i18next';

import { Byline } from '../Byline/Byline';

import type { VFC } from 'react';
import type { CnpAuthor } from '@vgtv/api-client/lib/cnp_authors';

import styles from './Bylines.module.scss';

interface BylineProps {
  authors: CnpAuthor[];
}

export const Bylines: VFC<BylineProps> = ({ authors }) => {
  const { t } = useTranslation();
  return (
    <div className={styles.byline}>
      {t('By')}
      {authors.length === 1 && <Byline author={authors[0]}></Byline>}
      {authors.length === 2 && (
        <>
          <Byline author={authors[0]}></Byline>
          {t('and')}
          <Byline author={authors[1]} />
        </>
      )}
      {authors.length !== 1 && authors.length !== 2 && (
        <>
          {authors.slice(0, -1).map((author) => (
            <span key={author.id}>
              <Byline author={author}></Byline>
              {','}
            </span>
          ))}
          {t('and')}
          <Byline author={authors[authors.length - 1]}></Byline>
        </>
      )}
      {'.'}
    </div>
  );
};
